module.exports = __webpack_public_path__ + "img/chapter_img.8d2a599.svg";